import { Card } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { FiUsers } from "react-icons/fi";
import s from "./dashboard.module.css";
import Graph from "./Graph";
import Graph1 from "./Graph1";
import { get_dashboard_api } from "../api/dashboard";
import { UserContext } from "../../App";
import PujaChart from "./PujaChart";
const Home = () => {
  const { state, dispatch } = useContext(UserContext);
  const [dashboard, setDashboard] = useState({});
  const [topPujas, settopPujas] = useState([]);
  console.log(dashboard, " thisis hwiofhwefiofi");
  const cardArray = [
    {
      title: "Total Astrologer",
      icon: "2294",
    },
    {
      title: "Total Users",
      icon: "1584",
    },
    {
      title: "Today Users",
      icon: "1584",
    },
    {
      title: "Total Call's",
      icon: "1814",
    },
  ];
  useEffect(() => {
    getProfile();
  }, []);
  const getProfile = async () => {
    try {
      const res = await get_dashboard_api();
      if (res.data.success) {
        setDashboard(res?.data?.data);
        console.log(res?.data, " thi is the data of the dashboard");
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div style={{ paddingInline: "1rem", maxWidth: "1023px" }}>
        <div className="dashboard-section" style={{ marginTop: "1rem" }}>
          <div className={s["dashboard-header-container"]}>
            {Object.entries(dashboard).map(([key, value]) => (
              <Card className={s["dashbord-content"]}>
                <div class={s["dashboard-main-card"]}>
                  <div class={s["dashboard-card-content"]}>
                    <div class={s["card-title"]}>
                      <h6>{key?.split("_").join(" ").toUpperCase()}</h6>
                      <h4>{value}</h4>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
        <div className={s["graph-container"]}>
          <div className={s["graph-content"]}>
            <div
              className="graph-left"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Graph1 />
              <PujaChart settopPujas={settopPujas} />
            </div>
            <div className="graph-right  p-3 ms-2 bg-white shadow rounded">
              <table className="table table-bordered">
                <thead
                  className=" text-white"
                  style={{ backgroundColor: "#9e2a2b" }}
                >
                  <tr>
                    <th className="p-3">Top 5 Puja</th>
                    <th className="p-3 text-center">Count</th>
                  </tr>
                </thead>
                <tbody>
                  {topPujas?.map((item, index) => (
                    <tr key={index} className="table-light">
                      <td className="p-3">{item?.name}</td>
                      <td className="p-3 text-center">{item?.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {/* <div className={s["graph-content"]}>
            <div className="graph-left" style={{ width: "70%" }}>
              <PujaChart settopPujas={settopPujas} />
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Home;
